import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '@/components/Sidebar';
import QuickCaptureFab from '@/components/QuickCaptureFab';

const HIDE_FAB_PATHS = ['/onboarding', '/login', '/auth/callback'];

export default function AppShell() {
  const location = useLocation();
  const hideFab = HIDE_FAB_PATHS.some(p => location.pathname.startsWith(p));
  return (
    <div className="cd-app">
      <Sidebar />
      <main className="cd-main">
        <div key={location.pathname} className="cd-page" style={{ flex: 1, overflowY: 'auto' }}>
          <Outlet />
        </div>
      </main>
      {!hideFab && <QuickCaptureFab />}
    </div>
  );
}
